/* eslint-disable max-len */
/*
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2026 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/*
 * A React component for FeedbackFailureIcon
 *
 * @author Satyaki Bose
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const FeedbackFailureIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 18 18" fontSize="inherit">
    <path
      d="M11.1064 5.84277C11.3965 5.55264 11.867 5.55264 12.1572 5.84277C12.4473 6.1329 12.4473 6.60342 12.1572 6.89355L10.0507 9L12.1572 11.1064C12.4473 11.3966 12.4473 11.8671 12.1572 12.1572C11.867 12.4474 11.3965 12.4474 11.1064 12.1572L8.99994 10.0508L6.8935 12.1572C6.60337 12.4474 6.13285 12.4474 5.84272 12.1572C5.55259 11.8671 5.55259 11.3966 5.84272 11.1064L7.94916 9L5.84272 6.89355C5.55259 6.60342 5.55259 6.1329 5.84272 5.84277C6.13285 5.55264 6.60337 5.55264 6.8935 5.84277L8.99994 7.94922L11.1064 5.84277Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99994 0C10.1818 0 11.3524 0.233255 12.4443 0.685547C13.5361 1.13784 14.5286 1.8001 15.3642 2.63574C16.1998 3.47139 16.8621 4.46386 17.3144 5.55566C17.7667 6.64759 17.9999 7.8181 17.9999 9C17.9999 10.78 17.4722 12.52 16.4833 14C15.4945 15.4799 14.0887 16.6332 12.4443 17.3145C10.7997 17.9956 8.98991 18.1744 7.24408 17.8271C5.49827 17.4799 3.89435 16.6229 2.63569 15.3643C1.37702 14.1056 0.520067 12.5017 0.172796 10.7559C-0.174471 9.01003 0.00430274 7.2002 0.685491 5.55566C1.3667 3.91127 2.52 2.50547 3.99994 1.5166C5.47995 0.527742 7.21998 4.2418e-07 8.99994 0ZM8.99994 1.74609C8.04546 1.73891 7.099 1.9213 6.21576 2.2832C5.33242 2.64521 4.52947 3.17946 3.85444 3.85449C3.17941 4.52952 2.64515 5.33248 2.28315 6.21582C1.92124 7.09906 1.73885 8.04552 1.74604 9C1.74604 10.4347 2.17162 11.8374 2.96869 13.0303C3.76572 14.223 4.89825 15.1531 6.22358 15.7021C7.54905 16.2512 9.00787 16.3941 10.415 16.1143C11.8221 15.8344 13.1144 15.1434 14.1289 14.1289C15.1433 13.1144 15.8343 11.8222 16.1142 10.415C16.3941 9.00792 16.2511 7.54911 15.7021 6.22363C15.1531 4.89831 14.223 3.76578 13.0302 2.96875C11.8373 2.17167 10.4347 1.74609 8.99994 1.74609Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default FeedbackFailureIcon;
